import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_dashboard/campaigns/setup/planning/triggers",
)({
  component: RouteComponent,
  staticData: {
    isBreadcrumbRoot: true,
    crumb: "Salgstriggers",
    meta: {
      title: "Salgstriggers",
    },
  },
});

function RouteComponent() {
  return <Outlet />;
}
